module.exports = ":host .fake-input {\n  line-height: 30px; }\n"